import { RowSelectionState } from '@tanstack/react-table';
import { ExportArticleItem } from '@texas/api/endpoints/search/searchApi';
import { useCallback, useRef } from 'react';

interface SelectedRow {
  articleId: number;
  variantId: number;
  branchId: number;
}

export function useExportableArticles(exportArticleItems: ExportArticleItem[]) {
  const exportableArticles = useRef<ExportArticleItem[]>([]);

  const setExportableArticles = useCallback(
    (selectedRows: RowSelectionState) => {
      const selectedArticleIds = Object.keys(selectedRows)
        .map<SelectedRow>((x) => JSON.parse(x))
        .map((x) => x.articleId);

      const exportableArticleIds = exportableArticles.current.map((x) => x.id);

      const changedRows = selectedArticleIds
        .filter((x) => !exportableArticleIds.includes(x))
        .concat(
          exportableArticleIds.filter((x) => !selectedArticleIds.includes(x)),
        );

      for (let i = 0; i < changedRows.length; i++) {
        const changedRow = changedRows[i];

        if (selectedArticleIds.includes(changedRow)) {
          const article = exportArticleItems.find((x) => x.id === changedRow);

          if (!article) return;

          exportableArticles.current = [...exportableArticles.current, article];
        } else {
          exportableArticles.current = exportableArticles.current.filter(
            (x) => x.id !== changedRow,
          );
        }
      }
    },
    [exportArticleItems, exportableArticles],
  );

  return {
    exportableArticles,
    setExportableArticles,
  };
}
